import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  rulesDetailsContentSection: {
    marginTop: '1rem',
    marginBottom: '1rem'
  }
}));

export default useStyles;
